// extracted by mini-css-extract-plugin
export default {"GenerateOptimalButton":"GenerateOptimalButton_GenerateOptimalButton__Tf0QD"};